import PurchaseItemList from "./PurchaseItemList";

const purchaseItemRoutes = [
    {
        path: "/PurchaseItem/purchase-item-list",
        component: PurchaseItemList,
        permission: "Permissions.PurchaseItems.View",
      },
];
export default purchaseItemRoutes;